function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M20.651 115.896c9.558-8.355 15.922-12.029 19.092-11.02 4.753 1.731 11.455 1.731 17.721-2.374 13.396-8.645 12.528-24.866 12.528-24.865l-1.08-1.73s-12.1 7.783-13.608 8.648c-1.95 1.513-8.644 4.54-14.696-4.755-6.264-9.3-1.085-15.136.645-16.218 1.514-.865 13.614-8.863 13.614-8.863l-1.075-1.73s-14.049-7.137-27.226.646c0 .436-3.245 2.38-4.539 3.462-8.429 7.567-8.429 16-6.917 22.92.867 4.182-2.599 10.476-10.399 18.884A38.495 38.495 0 011 82.355C1 61.881 13.882 34.43 39.645 0c25.763 33.649 38.644 61.1 38.644 82.355C78.29 104.87 60.987 121 39.645 121c-5.517 0-11.848-1.701-18.994-5.104z"
});

function SvgTradePlumbingLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 122,
    viewBox: "0 0 79 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradePlumbingLarge);
export default __webpack_public_path__ + "static/media/TradePlumbingLarge.beb804e0.svg";
export { ForwardRef as ReactComponent };